import React from 'react'
import Button from 'meinian-package/src/baseComponent/button'
import { useNavigate } from 'react-router-dom'
import styles from './index.module.less'

export default function ErrorBoundary() {
  const history = useNavigate()
  return <div className={styles.errorBoundary}>
    <div className={styles.errorBoundaryWrap}>
      <img
        className={styles.errorBoundary404}
        src="https://zhiyi-image.oss-cn-hangzhou.aliyuncs.com/web/meinian-image/404.png"
      />
      <div className={styles.errorBoundaryContent1}>
        找不到页面
      </div>
      <div className={styles.errorBoundaryContent2}>
        抱歉，您访问的页面不存在，或已被删除
      </div>
      <Button type="primary" className={styles.errorBoundaryGoHome} onClick={() => history('/home')}>
        返回首页
      </Button>
    </div>
  </div>
}
